import React, { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { Card, CardBody, Col, Nav, NavItem, NavLink } from "reactstrap"
import SimpleBar from "simplebar-react"
import PropTypes from "prop-types"
import BootstrapTable from "react-bootstrap-table-next"
import moment from "moment"

const AccessTickets = ({ roles, sessionTickets, setRole, setSessionType }) => {
  const liveRoles = (roles || []).filter(el => el.status == "Available" || el.status == "Approved")
  const [activeTab, setActiveTab] = useState("all")

  const spListColumns = [
    {
      text: "id",
      dataField: "_id",
      sort: true,
      hidden: true,
      formatter: record => <>{record._id}</>,
    },
    {
      text: "Carpark Code",
      dataField: "carparkCode",
      sort: true,
      formatter: (cellContent, record) => (
        <>
          {(record?.carpark || "") }
        </>
      ),
    },
    {
      text: "Vehicle Details",
      dataField: "vehicleNumber",
      sort: true,
      formatter: (cellContent, record) => (
        <>
          <h5 className="font-size-12 mb-0 text-truncate">
            <Link to="#" className="text-dark">
              {record?.guestId?.guestName || record?.userId?.name ||  ""}
            </Link>
            <small className="ms-1 text-muted">
              {record?.carplate || record?.guestId?.guestVehicleNumber || ""}
            </small>
          </h5>
          <small className="text-muted">
            {record?.guestId?.guestName?"Guest": record?.userId?.role?.roleTitle}
            <span></span>
          </small>
        </>
      ),
    },
    {
      text: "Entry Date Time",
      dataField: "seasonStart",
      sort: true,
      formatter: (cellContent, record) => {
        return (
          <>
            {record
              ? moment(record.seasonStart).format("Do MMM YYYY, h:mm a")
              : ""}
          </>
        )
      },
    },
    {
      text: "Exit Date Time",
      dataField: "seasonEnd",
      sort: true,
      formatter: (cellContent, record) => {
        return (
          <>
            {record
              ? moment(record.seasonEnd).format("Do MMM YYYY, h:mm a")
              : ""}
          </>
        )
      },
    },
  ]

  const emptyDataMessage = () => {
    return <p style={{ textAlign: "center" }}>No data to display</p>
  }

  return (
    <React.Fragment>
      <Col xl={12}>
        <Card>
          <div className="bg-transparent border-bottom card-header">
            <div className="d-flex flex-wrap">
              <div className="me-2">
                <h5 className="card-title mt-1 mb-4">Access Tickets</h5>
              </div>
              <Nav
                className="nav-tabs nav-tabs-custom card-header-tabs ms-auto gap-1"
                role="tablist"
              >
                <NavItem
                  className="ms-1"
                  onClick={() => {
                    setActiveTab("all")
                    setSessionType("all")
                    setRole(null)
                  }}
                >
                  <NavLink
                    href="#"
                    className={activeTab == "all" ? "active" : ""}
                  >
                    All
                  </NavLink>
                </NavItem>
                {liveRoles.map(el => (
                 
                    <NavItem
                      className="ms-1"
                      key={el._id}
                      onClick={() => {
                        setActiveTab(el._id)
                        setRole(el._id)
                        setSessionType(null)
                      }}
                    >
                      <NavLink
                        href="#"
                        className={activeTab == el._id ? "active" : ""}
                      >
                        {el.roleTitle}
                      </NavLink>
                    </NavItem>
                  
                ))}
                <NavItem
                  className="ms-1"
                  onClick={() => {
                    setActiveTab("guest")
                    setSessionType("guest")
                    setRole(null)
                  }}
                >
                  <NavLink
                    href="#"
                    className={activeTab == "guest" ? "active" : ""}
                  >
                    Guest
                  </NavLink>
                </NavItem>
              </Nav>
            </div>
          </div>
          <CardBody>
            <SimpleBar style={{ maxHeight: "295px" }}>
              <div>
                <div className="tab-content">
                  <div className="tab-pane show active">
                    <BootstrapTable
                      data={sessionTickets}
                      columns={spListColumns}
                      keyField={"_id"}
                      //defaultSorted={defaultSorted}
                      classes={"table align-middle table-nowrap table-hover"}
                      bordered={false}
                      striped={false}
                      responsive
                      //ref={node}
                      noDataIndication={emptyDataMessage}
                    />
                  </div>
                </div>
              </div>
            </SimpleBar>
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  )
}

AccessTickets.propTypes = {
  roles: PropTypes.array,
  sessionTickets: PropTypes.array,
  setRole: PropTypes.func,
  setSessionType: PropTypes.func,
}

export default AccessTickets
